import { Assignment } from "seneca-common/features/assignments/state";
import { getDueDate } from "seneca-common/features/assignments/state/selectors/state/assignments/assignment";
import sortAscendingOrder from "seneca-common/utils/functions/sorting/sortAscendingOrder";
import sortDescendingOrder from "seneca-common/utils/functions/sorting/sortDescendingOrder";

export const sortByDueDateAsc = (a: Assignment, b: Assignment) =>
  sortAscendingOrder(getDueDate(a), getDueDate(b));

export const sortByDueDateDesc = (a: Assignment, b: Assignment) =>
  sortDescendingOrder(getDueDate(a), getDueDate(b));
